exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3s1374RkzmSSzt_hH_BgSY{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}._17mQ2BBEJjkFxT38SHMq3f{-webkit-flex-basis:100%;-ms-flex-preferred-size:100%;flex-basis:100%}@media only screen and (min-width:480px){._17mQ2BBEJjkFxT38SHMq3f{-webkit-flex-basis:50%;-ms-flex-preferred-size:50%;flex-basis:50%}}._37Lv0xiAVrpsAOo_myMrd_{padding:.57143rem 1.07143rem}._23rODRztetR0byTH3Hzsdx{font-size:1.07143rem;font-weight:600;margin:0}._1l5y5lf-oSehdy_u-SAVzp{margin-top:.71429rem}@media only screen and (min-width:480px){._1l5y5lf-oSehdy_u-SAVzp{margin-top:1.57143rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportStudentCard_profile": "_18Xjd5GQcnXb--7QL_Qb4v",
	"ReportStudentCard_content": "_3s1374RkzmSSzt_hH_BgSY",
	"ReportStudentCard_content_items": "_17mQ2BBEJjkFxT38SHMq3f",
	"ReportStudentCard_reportStatus": "_37Lv0xiAVrpsAOo_myMrd_",
	"ReportStudentCard_reportStatus_title": "_23rODRztetR0byTH3Hzsdx",
	"ReportStudentCard_reportStatus_status": "_1l5y5lf-oSehdy_u-SAVzp"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/ReportStudentCard/style.postcss
// module id = 1488
// module chunks = 0